import React from "react";
import Portal from "src/shared/components/Portal";
import { t } from "src/shared/locales/i18n";
import { DivCartSuccessModal } from "../style/CartSuccessModal.style";

interface Props {
  isCloseable?: boolean;
}

const CartSuccessModal = ({ isCloseable = false }: Props) => {
  const [isModalVisible, setIsModalVisible] = React.useState(true);

  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <Portal>
      <DivCartSuccessModal>
        {isModalVisible && (
          <div className="akn-cart-success-modal-wrapper">
            <div
              className="akn-cart-success-modal"
              onClick={isCloseable ? closeModal : () => null}
            >
              {isCloseable && (
                <div
                  className="akn-cart-success-modal__close"
                  onClick={closeModal}
                >
                  ✖
                </div>
              )}
              <span className="akn-cart-success-modal__icon">✓</span>
              <span className="akn-cart-success-modal__text">
                {t("added_to_cart")}
              </span>
            </div>
          </div>
        )}
      </DivCartSuccessModal>
    </Portal>
  );
};

export default CartSuccessModal;
